// components/global/ToasterProvider.jsx
import { useState, useCallback, useEffect } from "react";
import { Snackbar, Alert } from "@mui/material";

let showSnackbarExternally;

export const Toaster = {
  success: (msg) => showSnackbarExternally?.("success", msg),
  error: (msg) => showSnackbarExternally?.("error", msg),
  info: (msg) => showSnackbarExternally?.("info", msg),
  warning: (msg) => showSnackbarExternally?.("warning", msg),
};

const ToasterProvider = () => {
  const [snackbarOpen, setSnackbarOpen] = useState(false);
  const [snackbarSeverity, setSnackbarSeverity] = useState("info");
  const [snackbarMessage, setSnackbarMessage] = useState("");

  const handleClose = () => setSnackbarOpen(false);

  const showSnackbar = useCallback((severity, message) => {
    setSnackbarSeverity(severity);
    setSnackbarMessage(message);
    setSnackbarOpen(true);
  }, []);

  useEffect(() => {
    showSnackbarExternally = showSnackbar;
  }, [showSnackbar]);

  return (
    <Snackbar
      open={snackbarOpen}
      autoHideDuration={6000}
      onClose={handleClose}
      anchorOrigin={{ vertical: "top", horizontal: "right" }}
    >
      <Alert
        onClose={handleClose}
        severity={snackbarSeverity}
        sx={{ width: "100%" }}
      >
        {snackbarMessage}
      </Alert>
    </Snackbar>
  );
};

export default ToasterProvider;
